import { connect } from 'react-redux'
import { goBack, replace } from 'react-router-redux'

import { fetchServicing, approveServicing } from '../../actions/servicings'

import ConfirmServicingApproval from '../../components/servicings/confirm-servicing-approval'

function mapStateToProps (state, ownProps) {
  const servicing = state.servicings[ownProps.params.servicingId]

  if (!servicing) return { loading: true }

  return { servicing }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchServicing(ownProps.params.servicingId))

  const summaryURL = `summaries/${ownProps.params.workSummaryId}`

  return {
    onClose () {
      dispatch(replace(summaryURL))
    },

    onViewOpenIssues () {
      dispatch(replace(`${summaryURL}/${ownProps.params.servicingId}/issues`))
    },

    onApproveServicing () {
      dispatch(approveServicing(ownProps.params.servicingId))
        .then(() => dispatch(replace(summaryURL)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmServicingApproval)



// WEBPACK FOOTER //
// ./src/containers/servicings/confirm-servicing-approval-container.js